var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_839",
    "data-name": "Grupo 839",
    transform: "translate(-1122 -180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_267",
    "data-name": "Subtra\\xE7\\xE3o 267",
    d: "M9.364,9.759a4.928,4.928,0,0,0,4.947-4.879,4.947,4.947,0,0,0-9.894,0A4.928,4.928,0,0,0,9.364,9.759Zm0,1C5.085,10.608.29,13.226,0,15.315l.981,1.024A11.592,11.592,0,0,0,9.363,20a12.635,12.635,0,0,0,8.4-3.659L19,15.053C18.554,13.092,13.643,10.9,9.364,10.755Z",
    transform: "translate(1125 184)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_214",
    "data-name": "Elipse 214",
    transform: "translate(1122 180)",
    fill: "none",
    stroke: "#f8f9fa",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 11.75,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.f66e9a900ca9bf834ee11562c58a95c5.svg";
export { ForwardRef as ReactComponent };